import styled, { css } from 'styled-components'
import Icon from 'builder/components/Icon'
import Colors from 'builder/styles/colors'
import { DashboardBuilder } from 'builder/components/Icon/24x24'
import Button, { ButtonTheme } from 'builder/components/Button'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  padding: 12px 0 0;
  top: 0;
  position: fixed;
  background-color: white;
  gap: 5px;
  margin-left: 5px;
  left: 0;
  z-index: 1;
`

export const ToggleButton = styled.div`
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;

  &:hover {
    background-color: ${Colors.Blue10};
    svg {
      color: ${Colors.Blue50};
      fill: ${Colors.Blue50};
    }
  }

  ${Media.Phone`
    display: none;
  `}
`

export const CloseIcon = styled(Icon.CloseLarge)``
export const OpenIcon = styled(DashboardBuilder)``

export const ButtonContainer = styled.div`
  padding: 14px 0 0;
  position: absolute;
  left: 50px;
  top: 0;
  z-index: 1;

  ${Media.Phone`
    position: relative;
    left: 0;
    padding-left: 20px;
    margin-top: 2px;
    width: 100%;
    background: ${Colors.White};
  `}
`

export const DashboardButton = styled(Button).attrs({ theme: ButtonTheme.secondary })`
  border-radius: 32px;
  padding: 8px 16px;
  color: ${Colors.Neutral80};
  background-color: ${Colors.Neutral10};

  &:hover {
    color: ${Colors.Blue50};
  }
`

interface Props {
  isRbpStepFlowActive: boolean | null
}

export const SettingsContainer = styled.div<Props>(({ isRbpStepFlowActive }) => {
  return css`
    position: fixed;
    top: 16px;
    right: 16px;
    margin-left: 0;
    z-index: 1;

    ${Media.Laptop`
      position: absolute;
  `}

    ${Media.Tablet`
      display: ${isRbpStepFlowActive ? 'none' : 'block'};
    `};
  `
})

export const Profile = styled.div`
  right: 20px;
  cursor: pointer;
  position: fixed;
  top: 12px;
  margin-left: 0;
  z-index: 50;

  ${Media.Phone`
    position: absolute;
  `}
`

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 14px;
  right: 54%;

  @media (min-width: 1920px) {
    right: unset;
    left: 580px;
  }

  ${Media.Laptop`
    right: unset;
    left: 69%;
  `}

  ${Media.Tablet`
    right: unset;
    left: 440px;
  `}
`

export const ToggleContainerMobile = styled.div`
  background-color: ${Colors.Blue10};
  padding: 12px 8px 12px 16px;
  display: flex;
  border-radius: 12px;
  margin: 16px 20px -24px 20px;
`

export const ToggleTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 12px;
`

export const SendToRecuiters = styled.span`
  color: ${Colors.Neutral90};
  ${Typography.Caption};
  ${FontWeights.Medium};

  ${Media.Phone`
    color: ${Colors.Blue80};
  `}
`

export const Recruiters = styled.span`
  color: ${Colors.Neutral50};
  ${Typography.Tiny};

  ${Media.Phone`
    color: ${Colors.Blue80};
  `}
`

export const TooltipMobileContainer = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const HintIcon = styled(Icon.Info)`
  cursor: pointer;
  width: 20px;
  height: 20px;
  color: ${Colors.Blue50};
  border-radius: 20px;
  margin-left: 8px;

  &:hover {
    color: white;
    background-color: ${Colors.Blue50};
  }
`

export const HintIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
